import React from 'react';
import styled from 'styled-components';
import Icon from '~/components/atom/Icon';
import JustificationContainer from '~/components/atom/JustificationContainer';
import { Body } from '~/components/atom/Typography';

type Props = { note: string };

const Note: React.FCC<Props> = ({ note }) => (
  <JustificationContainer gap="xxs" align="center">
    <Icon name="message-square" color={{ group: 'primary' }} />
    <StyledBody margin={[null]} size="s" whiteSpace="nowrap" width="100%">
      {note}
    </StyledBody>
  </JustificationContainer>
);

const StyledBody = styled(Body)`
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 320px;
`;

export default Note;
